import { render, staticRenderFns } from "./follow_up_detail.vue?vue&type=template&id=c6e9c8fc&scoped=true&"
import script from "./follow_up_detail.vue?vue&type=script&lang=js&"
export * from "./follow_up_detail.vue?vue&type=script&lang=js&"
import style0 from "./follow_up_detail.vue?vue&type=style&index=0&id=c6e9c8fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e9c8fc",
  null
  
)

export default component.exports